import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

type MainLayoutProps = { children: ReactNode };

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
}
